import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';

import { Wrapper, AwardImage } from './styles';

function Awards({ sectionId, className, data }) {
  if (!data) return null;
  const { colourOverrideBackground, titleHtml, width, items, lang } = data;
  return (
    <Wrapper
      id={sectionId}
      className={[className, width, 'awards-banner']}
      colourOverrideBackground={colourOverrideBackground}
    >
      {ReactHtmlParser(titleHtml)}
      <ul>
        {items.map(({ image, imageSharp, hrefLink }, index) => (
          <li key={`awards-${image.url}-${index.toString()}`}>
            {hrefLink.url ? (
              <Link
                to={`${hrefLink.url}`}
                className="unstyled linkedImage"
                noSpan
                lang={lang}
              >
                {image.url && imageSharp && (
                  <AwardImage
                    src={imageSharp || image.url}
                    alt={image.altTag}
                  />
                )}
              </Link>
            ) : (
              <AwardImage src={imageSharp || image.url} alt={image.altTag} />
            )}
          </li>
        ))}
      </ul>
    </Wrapper>
  );
}

Awards.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
};

Awards.defaultProps = {
  className: null,
};

export default Awards;
